/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CreditCard16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M15 7v5a1 1 0 01-1 1H2a1 1 0 01-1-1V7h14zm-3.5 3h-1c-.667 0-.667 1 0 1h1c.667 0 .667-1 0-1zm-3 0h-5c-.667 0-.667 1 0 1h5c.667 0 .667-1 0-1zM1 4a1 1 0 011-1h12a1 1 0 011 1v1H1V4z"
        />
    </AccessibleSVG>
);

export default CreditCard16;
